import React, { useState, ChangeEvent } from 'react';
import { useStyles } from '../../style';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import KenButton from '../../../../GlobalComponents/KenButton';
import { CertificateDetails } from '../../../../interfaces/Profile';
import { postProfileCertificateDetails } from '../../../../Utils/apiService';
import dayjs, { Dayjs } from 'dayjs';
import { enqueueSnackbar } from 'notistack';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  width: { lg: '40vw', xl: '40vw' },
  p: 4,
  overflowY: 'auto',
};
const AddCertificateData = (props: any) => {
  console.log('props', props);
  const { userData, handleClose, value } = props;
  console.log('value35345', value);

  const [issueDate, setIssueDate] = useState<Dayjs | null>(dayjs(value?.Issue_Date__c ? value?.Issue_Date__c : dayjs()));
  const [formData, setFormData] = useState<CertificateDetails>({
    name: value?.Name ? value?.Name : '',
    contactId: userData?.applicantId,
    issueDate: value?.Issue_Date__c ? value?.Issue_Date__c : '',
    issuingOrganization: value?.Issuing_Organization__r?.Name ? value?.Issuing_Organization__r?.Name : '',
  });
  const classes = useStyles();

  const handleChangeField = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleChangeIssueDate = (newDate: Dayjs | null) => {
    setIssueDate(newDate);
  };

  const formatDate = (value: Dayjs | null): string => {
    if (value === null) {
      return '';
    }
    return value.format('YYYY-MM-DD');
  };

  const postCertificateDetails = () => {
    const dateValue: Dayjs | null = dayjs(issueDate);
    const formattedDate = formatDate(dateValue);
    const payload: any = {
      ...formData,
      issueDate: formattedDate,
    };
    console.log('payload324', payload);

    postProfileCertificateDetails(payload)
      .then((res) => {
        if (res?.success) {
          props.setPreferStatus(true);
          enqueueSnackbar({
            message: 'Certificate Details Saved Sucessfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
          props.handleClose();
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  };
  return (
    <div>
      <Box sx={style}>
        <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '13px' }}>{props.data == 'edit' ? 'Edit Certificate' : 'Add Certificate'}</Typography>
        <hr style={{ border: '1px solid #E6E6E8' }} />
        <Grid container spacing={2} sx={{ marginTop: '-40px' }}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography sx={{ fontWeight: 500, mt: 3, fontSize: '12px' }}>Certification Name</Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              placeholder="Enter certification name"
              name="name"
              value={formData.name}
              onChange={handleChangeField}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography sx={{ fontWeight: 500, mt: 3, fontSize: '12px' }}>Issuing Organization</Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              placeholder="Enter Issuing organization"
              name="issuingOrganization"
              value={formData.issuingOrganization}
              onChange={handleChangeField}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography sx={{ fontWeight: 500, mt: 1, fontSize: '12px' }}>Issue Date</Typography>
            <Box sx={{ mt: 1.5 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  value={issueDate}
                  onChange={handleChangeIssueDate}
                  slots={{
                    textField: (params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            height: '36px',
                            borderRadius: '6px',
                            fontSize: '12px',
                          },
                          '& .MuiOutlinedInput-input': {
                            fontSize: '12px',
                          },
                        }}
                      />
                    ),
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
          <KenButton
            variant="text"
            className={classes.button}
            sx={{
              mt: 1,
              borderRadius: '8px',
              width: 100,
              backgroundColor: 'transparent !important',
              color: 'black',
              '&:hover': {
                backgroundColor: 'transparent !important',
              },
              '&:active': {
                backgroundColor: 'transparent !important',
              },
              '&:focus': {
                backgroundColor: 'transparent !important',
              },
              '&:focus-visible': {
                backgroundColor: 'transparent !important',
              },
            }}
            onClick={() => handleClose()}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: '500', color: '#373A45' }}>Cancel</Typography>
          </KenButton>
          <KenButton
            variant="contained"
            className={classes.button}
            style={{ marginTop: 15, borderRadius: '8px', width: 100, marginLeft: 10, boxShadow: 'none', height: '36px' }}
            onClick={() => postCertificateDetails()}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>Save</Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default AddCertificateData;
